<template>
    <gmap-map
            ref="mapRef"
            :center="center"
            :zoom="zoom"
            :options="mapOptions"
            style="width: 100%; height: 500px">
        <gmap-marker
                v-for="(m, index) in markers"
                :key="index"
                :position="m"
                @click="setCenter(m)"
                icon="/img/icons/marker.svg"></gmap-marker>
    </gmap-map>
</template>

<script>
    import {MAP} from "@/store/types/modules";
    import {mapState, mapMutations} from 'vuex'

    export default {
        data() {
            return {
                map: null
            }
        },
        props: {
            zoom: {
                type: Number,
                default: 15
            },
            markers: Array
        },
        methods: {
            ...mapMutations(MAP, {
                setCenter: 'setCenter'
            })
        },
        computed: {
            ...mapState(MAP, {
                mapOptions: 'mapOptions',
                center: 'center'
            })
        },
        watch: {
            center: function (center) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    map.panTo(center)
                    map.setZoom(this.zoom)
                })
            }
        }
    }
</script>